"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../../shared"));

var _UserDropdown = _interopRequireDefault(require("./UserDropdown"));

var _UserNavUser = _interopRequireDefault(require("./UserNavUser"));

var _UserNavItem = _interopRequireDefault(require("./UserNavItem"));

var _UserNavLink = _interopRequireDefault(require("./UserNavLink"));

var _Avatar = _interopRequireDefault(require("../../Avatar/Avatar"));

var _Typography = _interopRequireDefault(require("../../Typography/Typography"));

var _Responsive = _interopRequireDefault(require("../../Responsive/Responsive"));

var _UserNavProducts = _interopRequireDefault(require("./UserNavProducts"));

var _UserNavFooter = _interopRequireDefault(require("./UserNavFooter"));

var _UserNav = _interopRequireDefault(require("./UserNav"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
User component for header bar
displays either just the name + avatar
or the name + avatar + dropdown
*/
function User(_ref) {
  var children = _ref.children,
      name = _ref.name,
      avatar = _ref.avatar,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["children", "name", "avatar", "className"]);

  var cssClasses = ['st_headerbar__item', 'st_headerbar__user'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: cssClasses.join(' ')
  }, otherProps), children && /*#__PURE__*/_react["default"].createElement(_UserDropdown["default"], {
    avatar: avatar,
    name: name
  }, children), !children && name && /*#__PURE__*/_react["default"].createElement(_Responsive["default"], {
    sm: true,
    md: true,
    lg: true
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    margin: {
      right: 'sm'
    },
    size: "md"
  }, name)), !children && /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    avatar: avatar,
    initials: name && name.charAt(0),
    size: "lg"
  }));
}

User.propTypes = {
  /** user name to display */
  name: _propTypes["default"].string,

  /** avatar of user, if any */
  avatar: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps
};
User.defaultProps = {
  name: null,
  avatar: null,
  className: null
};
User.Item = _UserNavItem["default"];
User.User = _UserNavUser["default"];
User.Link = _UserNavLink["default"];
User.Products = _UserNavProducts["default"];
User.Footer = _UserNavFooter["default"];
User.Dropdown = _UserDropdown["default"];
User.Nav = _UserNav["default"];
User.displayName = 'HeaderBar.User';
var _default = User;
exports["default"] = _default;